/**
 * index.js — Stimulus controllers bundle entrypoint (esbuild --bundle).
 *
 * The SINGLE esbuild-bundled file that owns the app-wide Stimulus Application and
 * glob-auto-registers every *_controller.js in this directory. This is the sole
 * controller delivery mechanism on every page (base.html + public_base.html) —
 * there are no per-controller <script> tags and no vendor UMD / stimulus-app.js
 * bootstrap; the @hotwired/stimulus runtime is bundled in here.
 *
 * Registration: esbuild-rails resolves the glob import below into an array of
 * { name, module } where `name` is the path-derived identifier
 * (add_price_controller.js -> "add-price"). No hand-maintained index, no per-file
 * register() call. The glob is RECURSIVE, so a controller in a subdirectory picks
 * up the Stimulus namespace prefix for that folder:
 * bridge/app_info_controller.js -> "bridge--app-info". Templates must use the
 * prefixed identifier or the controller silently never connects.
 *
 * Bootstrap semantics:
 *   - ONE Application instance; register() before start() just queues definitions.
 *   - start() is deferred to DOMContentLoaded ON PURPOSE. Application.start()
 *     resolves domReady() the instant readyState !== "loading", which is always
 *     true while deferred scripts run — starting then would connect() controllers
 *     before later deferred/inline scripts (window.api, Leaflet's window.L) exist.
 *     DOMContentLoaded fires only after every deferred + inline script has run.
 *
 * The ONLY other Stimulus Application is the calendar's: a separate lazy bundle
 * (calendar/core.js, PageLoader-loaded on calendar/schedule pages after the
 * FullCalendar vendor global) runs its own Application by design, so its
 * FullCalendar-dependent payload stays off every other page. This bundle does
 * not register a 'calendar' identifier; the two never collide.
 */
import { Application } from "@hotwired/stimulus";
import controllers from "./**/*_controller.js";

const application = new Application();

// Register every globbed controller under its filename-derived identifier.
controllers.forEach(({ name, module }) => {
  application.register(name, module.default);
});

// Defer router start to DOMContentLoaded (see header — race fix).
if (document.readyState === "complete") {
  application.start();
} else {
  document.addEventListener("DOMContentLoaded", () => application.start(), {
    once: true,
  });
}
